(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-welcome-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const offer = document.getElementById('ts-welcome-offer');
  if (!offer) return;
  const formId = 'RSkKU7';
  const storageKey = 'ts-welcome-offer-hidden-until';
  let dismissed = false;
  try { dismissed = Number(localStorage.getItem(storageKey)) > Date.now(); } catch (error) {}
  if (dismissed) return;
  offer.hidden = false;
  const openButton = offer.querySelector('.ts-welcome-offer__open');
  const dismiss = (days) => {
    dismissed = true;
    offer.hidden = true;
    try { localStorage.setItem(storageKey, String(Date.now() + days * 86400000)); } catch (error) {}
  };
  offer.querySelector('.ts-welcome-offer__close').addEventListener('click', () => dismiss(7));
  openButton.addEventListener('click', () => {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.formId !== formId) return;
    if (event.detail.type === 'open') offer.hidden = true;
    if (event.detail.type === 'submit') dismiss(365);
    if (event.detail.type === 'close' && !dismissed) {
      offer.hidden = false;
      openButton.focus({preventScroll:true});
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
